import { GeneralModel } from "./general.model";

export class ListGoodsStatus  extends GeneralModel{

}
